<img [src]="src" [ngStyle]="imageStyles">
